// src/components/TrendCharts.js
import React, { useEffect, useState } from "react";
import { Column, Pie } from "@ant-design/charts";
import axios from "axios";

const TrendCharts = () => {
  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Convert latitude to region (very simplified)
  const getRegion = (lat) => {
    if (lat > 30 && lat <= 60) return "North America";
    if (lat >= -35 && lat <= 35) return "Africa";
    if (lat > 5 && lat <= 55) return "Asia";
    if (lat < -15 && lat >= -55) return "South America";
    if (lat > 35 && lat <= 70) return "Europe";
    return "Other";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("https://node-api-dot-crisisvision-ai-backend.uc.r.appspot.com/api/crises");
        const crisisData = res.data;

        // Build bar data by region
        const regionMap = {};
        crisisData.forEach((c) => {
          const region = getRegion(c.location.lat);
          regionMap[region] = (regionMap[region] || 0) + 1;
        });

        const bar = Object.entries(regionMap).map(([region, cases]) => ({
          region,
          cases,
        }));

        setBarData(bar);

        // Build pie data (simulate some other crisis types for realism)
        const pie = [
          { type: "Wildfire", value: crisisData.length },
          { type: "Flood", value: Math.floor(crisisData.length * 0.25) },
          { type: "Pollution", value: Math.floor(crisisData.length * 0.2) },
          { type: "Disease", value: Math.floor(crisisData.length * 0.35) },
        ];

        setPieData(pie);
        setLoading(false);
      } catch (error) {
        console.error("Error loading chart data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const barConfig = {
    data: barData,
    xField: "region",
    yField: "cases",
    columnWidthRatio: 0.6,
    colorField: "region",
    scale: {
      color: {
        range: ["#004d66", "#faad14", "#a0d911", "#52c41a", "#13c2c2"],
      },
    },
    meta: {
      cases: {
        alias: "Number of Cases",
      },
    },
  };

  const pieConfig = {
    appendPadding: 10,
    data: pieData,
    angleField: "value",
    colorField: "type",
    scale: {
      color: {
        range: ["#556B2F", "#800000", "#191970", "#696969", "#13c2c2"],
      },
    },
    radius: 1,
    innerRadius: 0.4,
    interactions: [{ type: "element-active" }],
    legend: { position: "bottom" },
  };

  if (loading) return <p>Loading crisis charts...</p>;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "2rem",
        marginTop: "2rem",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          flex: 1,
          minWidth: "300px",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Regional Crisis Comparison
        </h3>
        <Column {...barConfig} />
      </div>

      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          flex: 1,
          minWidth: "300px",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Crisis Distribution (This Year)
        </h3>
        <Pie {...pieConfig} />
      </div>
    </div>
  );
};

export default TrendCharts;
